import { Form } from '@components/Form';

interface SubmitButtonProps {
  label: string;
}

export function SubmitButton({ label }: SubmitButtonProps) {
  return (
    <Form.SubmitButton
      mode="create"
      label={label}
    />
  );
}
